<template>
    <div class="d-flex align-items-center flex-wrap">
        <div class="col-12 d-flex justify-content-center align-items-center text-warning">
            <h1 class="me-2">
                404
            </h1>
            <h2 class="mx-4">
                |
            </h2>
            <h2 class="text-uppercase font-monospace">
                {{ $t('NotFound.PageNotFound') }}
            </h2>
        </div>
        <div class="col-12 text-center">
            <h2>
                {{ $t('NotFound.lost') }}
            </h2>
        </div>
        <div class="col-12 text-center my-5">
            <img src="@/assets/img/lost.png" class="w-25" alt="lost">
        </div>
        <div class="col-12 text-center">
            <router-link to="/" class="btn btn-lg btn-auth btn-nav rounded-pill">
                {{ $t('NotFound.back_to_portal') }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style lang="scss" scoped>
    h1 {
        font-size: 100px;
    }
</style>